import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAccountAction, useAccountSelect } from 'src/hooks/useAccount'
import { useAppAction } from 'src/hooks/useApp'
import { usePresenceAction } from 'src/hooks/usePresence'
import { presenceService } from 'src/services/presence'

/**
 * Headless: enters presence once the profile (and with it the channel name) is known, keeps the
 * self-heal check fed, and reminds about a manually pinned status once per page load.
 */
const PresenceBootstrap = () => {
  const { t } = useTranslation('presence')
  const user = useAccountSelect.user()
  const startPresence = usePresenceAction.start()
  const toast = useAppAction.tost()
  const reminded = React.useRef(false)
  const isProfileFresh = useAccountAction.getProfile.status().isFulfilled

  const presence = user?.presence

  React.useEffect(() => {
    if (presence?.channel) startPresence({ channel: presence.channel })
  }, [presence?.channel])

  React.useEffect(() => {
    if (!presence) return

    presenceService.reportBackendStatus(
      presence.status,
      presence.statusIsManual
    )
  }, [presence?.status, presence?.statusIsManual, presence?.rev])

  // Only the status the app STARTED with is worth a reminder ("you left Do not disturb on
  // yesterday"), not the one the user has just picked. The profile kept in localStorage may be
  // stale, so wait for the fresh one
  React.useEffect(() => {
    if (!isProfileFresh || !presence || reminded.current) return
    reminded.current = true

    if (
      presence.statusIsManual &&
      (presence.status === 'dnd' || presence.status === 'offline')
    ) {
      toast({
        type: 'warning',
        title: t('reminder.title'),
        description: t(`reminder.${presence.status}`),
      })
    }
  }, [isProfileFresh, Boolean(presence)])

  return null
}

export default PresenceBootstrap
